import { render, staticRenderFns } from "./collectNodeErrDataReport.vue?vue&type=template&id=61a119d0&scoped=true"
import script from "./collectNodeErrDataReport.vue?vue&type=script&lang=js"
export * from "./collectNodeErrDataReport.vue?vue&type=script&lang=js"
import style0 from "./collectNodeErrDataReport.vue?vue&type=style&index=0&id=61a119d0&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61a119d0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/重构-快递前端-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('61a119d0')) {
      api.createRecord('61a119d0', component.options)
    } else {
      api.reload('61a119d0', component.options)
    }
    module.hot.accept("./collectNodeErrDataReport.vue?vue&type=template&id=61a119d0&scoped=true", function () {
      api.rerender('61a119d0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/collectionCenter/Report/collectNodeErrDataReport.vue"
export default component.exports